<template>
  <div>
  <Modal title="查看上课情况" v-model="visible" width="815">
    <Table class="compact" size="small" :columns="column" :data="dataList"></Table>
    <div slot="footer">
      <Button size="large" @click="cancelAbsent" type="primary">取消学生旷课</Button>
    </div>
  </Modal>
  </div>
</template>
<script>
  export default {
    name: 'LessonMemberTimeModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      openedId: {
        type: Number
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      let $moment = this.$moment
      return {
        visible: this.value,
        dataList: [],
        column: [
          {
            title: '老师进教室时间',
            width: 135,
            align: 'center',
            render: (h, params) => {
              if (params.row.tchStartTime === 0) {
                return h('span', '')
              }
              return h('span', $moment(params.row.tchStartTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '老师最后出教室时间',
            width: 135,
            align: 'center',
            render: (h, params) => {
              if (params.row.tchEndTime === 0) {
                return h('span', '')
              }
              return h('span', $moment(params.row.tchEndTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '学生进教室时间',
            width: 135,
            align: 'center',
            render: (h, params) => {
              if (params.row.sdStartTime === 0) {
                return h('span', '')
              }
              return h('span', $moment(params.row.sdStartTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '学生出教室时间',
            width: 135,
            align: 'center',
            render: (h, params) => {
              if (params.row.sdEndTime === 0) {
                return h('span', '')
              }
              return h('span', $moment(params.row.sdEndTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '老师授课时间(秒)',
            width: 120,
            align: 'center',
            render: (h, params) => {
              return h('span', params.row.tchTime)
            }
          },
          {
            title: '学生学习时间(秒)',
            width: 121,
            align: 'center',
            render: (h, params) => {
              return h('span', params.row.sdTime)
            }
          },
        ]
      }
    },
    methods: {
      cancelAbsent () {
        let self = this
        this.$Modal.confirm({
          title: '提示',
          content: '是否<span style="color: red">取消</span>该旷课?',
          width: 300,
          okText: '确认关闭',
          loading: true,
          onOk: () => {
            this.$http.post('/bc/cancelStudentAbsent', {lsnOpenId: self.openedId}).then(res => {
              if (res) {
                self.$Message.success('更改成功')
                self.$Modal.remove()
                self.visible = false
                self.$emit('on-close')
              }
            })
          }
        })
      },
      onLoad () {
        let self = this
        let loadMsg = this.$Message.loading('正在加载中...', 0)
        self.$http.get('/bookLesson/getClassMemberTime', { params: {lsnOpenId: self.openedId} }).then(function (res) {
          loadMsg()
          if (!res || !res.data) {
            return
          }
          self.dataList = [res.data]
          self.visible = true
        })
      }
    },
    watch: {
      value (val) {
        if (val === true) {
          this.onLoad()
        } else {
          this.visible = val
        }
      },
      visible (val) {
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LessonMemberTimeModal.vue?02a6b81e